var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointmentsExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:50px;}.cls-2{stroke-miterlimit:10;}.cls-3{stroke-linejoin:round;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expired"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.76,201.8a158,158,0,1,1-20.67,156.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "297.14 225.67 297.14 303.65 362.37 331.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.46,254.22l-17.57-87.65c-3-15.12,14.22-26,26.53-16.7l106.67,80.31c12.31,9.27,6.65,28.85-8.71,30.11l-89.1,7.35A16.77,16.77,0,0,1,118.46,254.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsExpired);
export default __webpack_public_path__ + "static/media/appointments_expired.332628bbcb5aef81dbbc853af93ecd68.svg";
export { ForwardRef as ReactComponent };